enum RouteEndpointsAuth {
  LOGIN = '/login',
}

export default RouteEndpointsAuth;
